export const mucNs = 'http://jabber.org/protocol/muc';
export const mucUserNs = `${mucNs}#user`;
export const mucAdminNs = `${mucNs}#admin`;
export const mucOwnerNs = `${mucNs}#owner`;
export const mucRoomConfigFormNs = `${mucNs}#roomconfig`;
export const mucRequestFormNs = `${mucNs}#request`;
